import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';


const BillingPayment = () => {

  const navigate = useNavigate();  

  const options = [
    {
      name: 'Payment Setting',
      link: 'payment-setting',
    },
    {
      name: 'Payment Activity',
      link: 'payment-activity',
    }
  ];

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light px-3 py-2 rounded-3 d-flex flex-wrap align-items-center justify-content-between gap-3'>
          <h4 className='mb-0'>Billing & Payment</h4>

          <select className="form-select w-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>

        {/* Options */}
        <div className='d-flex flex-wrap gap-3 align-items-center justify-content-between my-3'>
          {
            options.map((value, index) => (
              <div className={`${window.location.href.includes(value.link) ? 'bg-primary text-white' : 'bg-light text-secondary'}  flex-grow-1 py-2 rounded-3 text-center fs-5`} onClick={() => navigate(value.link)} key={index}>{value.name}</div>
            ))
          }
        </div>

        <Outlet />
      </section> 
    </>
  )
}

export default BillingPayment
